import { LocalStorageNumber } from '../decorators/local-storage';
import { LogLevel } from '../services/logging/log-level.enum';

/**
 * This is used to centralize storage access,
 * which allows us enforce consistency of value names & types.
 */
export class LocalStorageUtil {
  /** */
  @LocalStorageNumber(LocalStorageUtil.LOG_LEVEL, LogLevel.None)
  public static logLevel: LogLevel;
  public static readonly LOG_LEVEL = 'logLevel';
}
